import React, { useState } from 'react';
import { api } from '../services/apiService';
import "../styles/UploadCV.css";

const UploadCV = ({ setCvText, goToNextStep }) => {
  const [loading, setLoading] = useState(false);
  const [fileName, setFileName] = useState('');

  const handleUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setFileName(file.name);
    setLoading(true);

    const formData = new FormData();
    formData.append('file', file);

    try {
      const result = await api.post('/cv/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      // On passe le texte anonymisé au composant parent
      setCvText(result.anonymized_text);
      
      goToNextStep('start');
    } catch (error) {
      console.error('Erreur lors de l\'upload du CV :', error);
      alert('Une erreur s\'est produite lors de l\'upload du CV. Veuillez réessayer.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="upload-container">
      <h2>Insérez votre CV</h2>
      <p className="privacy-notice">
        🔒 Vos données personnelles seront automatiquement anonymisées pour garantir votre confidentialité.
      </p>
      {loading ? (
        <div className="loading-wrapper">
          <p className="loading-message">Traitement et anonymisation en cours...</p>
          <div className="loading-spinner"></div>
        </div>
      ) : (
        <div className="upload-wrapper">
          <label htmlFor="file-upload" className="custom-file-upload">
            {fileName || 'Choisir un fichier'}
          </label>
          <input
            id="file-upload"
            type="file"
            accept=".pdf,.docx"
            onChange={handleUpload}
            className="file-input"
          />
          <p className="file-format-info">
            Formats acceptés : PDF, DOCX
          </p>
        </div>
      )}
    </div>
  );
};

export default UploadCV;